import { Rotate as OlRotate } from 'ol/control';
import { useContext, useEffect, useState } from 'react';
import MapContext from '../MapContext';
import './Rotate.scss';


export default function Rotate() {

    const map = useContext(MapContext)

    useEffect(() => {
        const rotate = new OlRotate(); 
        map.addControl(rotate);
    
      return () => {
        map.removeControl(rotate)
      }
    }, [])
    

  return (
      <></>
  )
}
